//Portuguese desktop banners
import banner01 from '../assets/banners/portuguese/banner01.png'
import banner02 from '../assets/banners/portuguese/banner02.png'
import banner03 from '../assets/banners/portuguese/banner03.png';
import banner04 from '../assets/banners/portuguese/banner04.png';
import banner05 from '../assets/banners/portuguese/banner05.png';

//English desktop banners
import bannerEng01 from '../assets/banners/english/bannerEng01.png'
import bannerEng02 from '../assets/banners/english/bannerEng02.png'
import bannerEng03 from '../assets/banners/english/bannerEng03.png';
import bannerEng04 from '../assets/banners/english/bannerEng04.png';
import bannerEng05 from '../assets/banners/english/bannerEng05.png';

const banners = [
    {
        ptBR: banner01,
        eng: bannerEng01,
        reference: 'https://br.freepik.com/fotos-gratis/feche-o-retrato-das-maos-de-uma-jovem-segurando-um-tubo-de-ensaio-com-um-liquido-amarelo_10271442.htm#fromView=search&page=1&position=33&uuid=3c454d5c-128f-4597-a31b-dc4d2ca42aad&query=chemical+laboratory'
    },
    {
        ptBR: banner02,
        eng: bannerEng02,
        reference: 'https://br.freepik.com/fotos-gratis/conta-de-papel-no-local-de-trabalho-do-projeto-de-financas-do-encontro_1235722.htm#fromView=keyword&page=1&position=1&uuid=7b4cd593-4242-4829-9b6e-ddca2c4697f5&query=Estatistica'
    },
    {
        ptBR: banner03,
        eng: bannerEng03,
        reference: 'https://br.freepik.com/fotos-gratis/pessoas-a-usar-um-dispositivo-digital-durante-uma-reuniao_17873508.htm#fromView=search&page=1&position=14&uuid=1f8bdc36-df0c-4b83-8b34-f3f1c30c5528&query=bussiness+meeting'
    },
    {
        ptBR: banner04,
        eng: bannerEng04,
        reference: 'https://br.freepik.com/fotos-gratis/representacao-da-experiencia-do-utilizador-e-design-da-interface_94963699.htm'
    },
    {
        ptBR: banner05,
        eng: bannerEng05,
        reference: 'https://br.freepik.com/imagem-ia-gratis/elementos-de-investigacao-e-inovacao-do-dia-mundial-da-ciencia_317003574.htm#position=2'
    },
]

export default banners;
